import type {CategoryType} from '@/redux/reducers/filterSettingsReducer';
import type {ComponentProps} from 'react';
import type Props from './typings';

import Accordion from '@/molecules/Accordion/Accordion';
import List from '@/molecules/List/List';
import {getPlpFilterCategoryOptions} from '@/services/plp-service';

import StyledCategory from './styles';

const list = getPlpFilterCategoryOptions({
  isNewNavigation: process.env.NEXT_PUBLIC_NAVIGATION === 'new',
});

const inputFormatter = (productCategory: string[], productType: CategoryType) => {
  const selection = productCategory.map((category) => {
    const option: ComponentProps<typeof List>['selected'][number] = {value: category};
    if (Array.isArray(productType[category]) && productType[category].length > 0) {
      option.subcategories = productType[category].map((subcategory) => ({
        value: subcategory,
      }));
    }
    return option;
  });
  return selection;
};

export const getCategoryTitle = (selectedCategories: string[], selectedType: CategoryType) => {
  const titleArray: string[] = [];

  if (!!selectedCategories.length) {
    const filterCategoryOptions = getPlpFilterCategoryOptions({
      isNewNavigation: process.env.NEXT_PUBLIC_NAVIGATION === 'new',
    });
    const lookupValue = inputFormatter(selectedCategories, selectedType)[0].value;
    const selectedOption = filterCategoryOptions.options.find(
      (option) => option.value === lookupValue.toString(),
    );
    if (selectedOption) titleArray.push(selectedOption.label);
  }

  return {label: titleArray, count: selectedCategories.length};
};

const Category = ({
  selected,
  categoryCallback,
  collapsible = false,
  defaultCollapsed = false,
}: Props) => {
  const title = 'Category';
  const subtitle = 'Select one medium.';

  const collapsibleFragment = () => {
    return (
      <Accordion title={title} subtitle={subtitle} defaultCollapsed={defaultCollapsed}>
        <List
          options={list.options}
          type={list.type}
          style={list.style}
          group="categories"
          selected={inputFormatter(selected.categories, selected.types)}
          callback={categoryCallback}
        />
      </Accordion>
    );
  };

  const fragment = () => {
    return (
      <StyledCategory>
        <h4>{title}</h4>

        <p>{subtitle}</p>

        <List
          options={list.options}
          type={list.type}
          style={list.style}
          group="categories"
          selected={inputFormatter(selected.categories, selected.types)}
          callback={categoryCallback}
        />
      </StyledCategory>
    );
  };

  return collapsible === true ? collapsibleFragment() : fragment();
};

export default Category;
